import { Clock } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../../Components/Admin/AdminLayout';
import {
    getProductRef,
    productsRef,
    serverTimestamp,
} from '../../firebase/collections';

function AdminAds() {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [moderationFilter, setModerationFilter] = useState('');

  useEffect(() => {
    let q = productsRef().orderBy('createdAt', 'desc').limit(100);
    if (moderationFilter) {
      q = productsRef()
        .where('moderationStatus', '==', moderationFilter)
        .orderBy('createdAt', 'desc')
        .limit(100);
    }
    q.get()
      .then((snap) => {
        setAds(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      })
      .catch((err) => {
        console.error('AdminAds fetch error:', err);
        setAds([]);
      })
      .finally(() => setLoading(false));
  }, [moderationFilter]);

  const updateModeration = (id, status) => {
    getProductRef(id)
      .update({ moderationStatus: status, updatedAt: serverTimestamp() })
      .then(() => {
        setAds((prev) =>
          prev.map((a) =>
            a.id === id ? { ...a, moderationStatus: status } : a
          )
        );
      });
  };

  const updateFeatured = (id, status) => {
    const updates = {
      featuredRequestStatus: status,
      updatedAt: serverTimestamp(),
    };
    if (status === 'approved') {
      updates.marketingScore = 100; // Push to Quick Menu
    } else {
      updates.marketingScore = 0;
    }

    getProductRef(id)
      .update(updates)
      .then(() => {
        setAds((prev) =>
          prev.map((a) =>
            a.id === id
              ? { ...a, featuredRequestStatus: status, marketingScore: updates.marketingScore }
              : a
          )
        );
      });
  };

  return (
    <AdminLayout>
      <h1>Ads</h1>
      <div className="adminFilters">
        <label>Moderation: </label>
        <select
          value={moderationFilter}
          onChange={(e) => setModerationFilter(e.target.value)}
        >
          <option value="">All</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
          <option value="flagged">Flagged</option>
        </select>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="adminTableWrap">
          <table className="adminTable">
            <thead>
              <tr>
                <th>Title</th>
                <th>Category</th>
                <th>Status</th>
                <th>Moderation</th>
                <th>Featured</th>
                <th>Reports</th>
                <th>Link</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {ads.map((a) => (
                <tr key={a.id}>
                  <td>{a.name}</td>
                  <td>{a.category}</td>
                  <td>{a.status || 'active'}</td>
                  <td>
                    <span className={`statusBadge ${a.moderationStatus || 'approved'}`}>
                      {a.moderationStatus || 'approved'}
                    </span>
                  </td>
                  <td>
                    <span className={`statusBadge ${a.featuredRequestStatus || 'none'}`}>
                      {a.featuredRequestStatus === 'requested' ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <Clock size={12} /> Requested
                        </div>
                      ) : (
                        a.featuredRequestStatus || 'None'
                      )}
                    </span>
                  </td>
                  <td>{a.reportCount || 0}</td>
                  <td>
                    <Link
                      to={`/ad/${a.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </Link>
                  </td>
                  <td>
                    <div className="adminActionsCell">
                      {/* Moderation Actions */}
                      {a.moderationStatus !== 'approved' && (
                        <button
                          type="button"
                          className="adminActionBtn approve"
                          onClick={() => updateModeration(a.id, 'approved')}
                        >
                          Approve
                        </button>
                      )}
                      {a.moderationStatus !== 'rejected' && (
                        <button
                          type="button"
                          className="adminActionBtn reject"
                          onClick={() => updateModeration(a.id, 'rejected')}
                        >
                          Reject
                        </button>
                      )}
                      {a.moderationStatus !== 'flagged' && (
                        <button
                          type="button"
                          className="adminActionBtn flag"
                          onClick={() => updateModeration(a.id, 'flagged')}
                        >
                          Flag
                        </button>
                      )}

                      {/* Featured Actions */}
                      {a.featuredRequestStatus === 'requested' && (
                        <div className="adminFeaturedActions">
                          <hr />
                          <button
                            type="button"
                            className="adminActionBtn featured"
                            onClick={() => updateFeatured(a.id, 'approved')}
                          >
                            Approve Featured
                          </button>
                          <button
                            type="button"
                            className="adminActionBtn reject"
                            onClick={() => updateFeatured(a.id, 'rejected')}
                          >
                            Deny Featured
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}

export default AdminAds;
